import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'HISTORY_ENTRY'

export type HistoryEntryState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function historyEntryReducer(state: HistoryEntryState = initialState, action: AnyAction): HistoryEntryState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
